const options = {
  every: 10,
  ticks: 50,
  promise: false
}
export default class Animate {
  constructor() {
    this.isRunning = false
  }
  data (from, to) {
    this.stop()
    this.from = from
    this.to = to
    return this
  }
  run (cb, opts={}) {
    opts = Object.assign(
      {},
      options,
      opts
    )
    let next = this.from
    let step = (this.to - this.from) / opts.ticks
    this.steps = Array.from({length: opts.ticks - 1}, () => next += step)
    this.steps.push(this.to)
    this.interval = setInterval(
      () => this.next(cb),
      opts.every
    )
    this.isRunning = true
    if (opts.promise) {
      const prom = new Promise(resolve => {
        this.resolve = resolve
      })

      return prom
    } else {
      this.resolve = null
    }
    
    return this
  }
  next (cb) {
    let value = this.steps.shift()
    if (typeof value !== 'undefined') {
      cb(value)
    }
    if (!this.steps.length) {
      this.stop()
    }
    return this
  }
  stop () {
    if (this.isRunning && this.interval) {
      clearInterval(this.interval)
      this.interval = null
      this.steps = []
      this.running = false
    }
    if (this.resolve) {
      this.resolve(this.to)
    }
    return this
  }

}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/animate.js